import { render, staticRenderFns } from "./key_value.vue?vue&type=template&id=09e96501&"
import script from "./key_value.vue?vue&type=script&lang=js&"
export * from "./key_value.vue?vue&type=script&lang=js&"
import style0 from "./key_value.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3812539345/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09e96501')) {
      api.createRecord('09e96501', component.options)
    } else {
      api.reload('09e96501', component.options)
    }
    module.hot.accept("./key_value.vue?vue&type=template&id=09e96501&", function () {
      api.rerender('09e96501', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parties/form/key_value.vue"
export default component.exports